var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleEllipsisVerticalSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-ellipsis-vertical-solid",
    d: "M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24Zm0-13.5A1.5,1.5,0,1,1,10.5,12,1.5,1.5,0,0,1,12,10.5Zm-1.5-3A1.5,1.5,0,1,1,12,9,1.5,1.5,0,0,1,10.5,7.5ZM12,15a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,15Z",
    fill: "#8e9ea0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEllipsisVerticalSolid);
export default __webpack_public_path__ + "static/media/circle-ellipsis-vertical-solid.b5e9d640f61c9a6f3a10b02f7e98264c.svg";
export { ForwardRef as ReactComponent };